import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
// import { FlexLayoutModule } from '@angular/flex-layout';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { CookieService } from 'ngx-cookie-service';
import { FuseShortcutsComponent } from './shortcuts.component';
import { FormsModule } from '@angular/forms';
import { HeaderService } from '../../services/header-service';
import { SharedModule } from 'app/modules/common/shared.module';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatListModule } from '@angular/material/list';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { TreeViewComponent } from '../tree-view/tree-view.component';
import { FuseWidgetModule } from '../widget/widget.module';
import { TransferActuacionesModalComponent } from './popups/transfer-actuaciones-modal/transfer-actuaciones-modal.component';
import { AngularMaterialModule } from 'app/angular-material.module';
import { CerrarfacturacionModalComponent } from './popups/cerrarfacturacion-modal/cerrarfacturacion-modal.component';
import { DischargesPopupComponent } from './sending-menu/discharges-popup/discharges-popup.component';
import { ReportsPopupComponent } from './sending-menu/reports-popup/reports-popup.component';
import { TaskEliminationPopupComponent } from './sending-menu/task-elimination-popup/task-elimination-popup.component';
import { TaskPopupComponent } from './sending-menu/task-popup/task-popup.component';
import { OpenDischargeRequestPopupComponent } from './sending-menu/open-discharge-request-popup/open-discharge-request-popup.component';
import { OpenAddressRequestPopupComponent } from './sending-menu/open-address-request-popup/open-address-request-popup.component';
import { OpenStaffRequestPopupComponent } from './sending-menu/open-staff-request-popup/open-staff-request-popup.component';
import { SendCitationsComponent } from './sending-menu/send-citations/send-citations.component';
import { DataCancelComponent } from './popups/data-cancel/data-cancel.component';
import { DerivarMutuaComponent } from './popups/derivar-mutua/derivar-mutua.component';

@NgModule({
    declarations: [
        FuseShortcutsComponent,
        TreeViewComponent,
        TransferActuacionesModalComponent,
        CerrarfacturacionModalComponent,
        DischargesPopupComponent,
        ReportsPopupComponent,
        TaskEliminationPopupComponent,
        TaskPopupComponent,
        OpenDischargeRequestPopupComponent,
        OpenAddressRequestPopupComponent,
        OpenStaffRequestPopupComponent,
        SendCitationsComponent,
        DataCancelComponent,
        DerivarMutuaComponent,
    ],
    imports: [
        CommonModule,
        RouterModule,
        FlexLayoutModule,
        MatButtonModule,
        MatDividerModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatMenuModule,
        MatListModule,
        MatTooltipModule,
        MatSelectModule,
        FormsModule,
        MatAutocompleteModule,
        SharedModule,
        FuseWidgetModule,
        AngularMaterialModule,
    ],
    exports: [
        FuseShortcutsComponent,
        MatSelectModule,
        TreeViewComponent
    ],
    providers: [
        CookieService,
        HeaderService
    ]
})
export class FuseShortcutsModule {
}
